// date-utils.js — 全项目共享日期工具（收拢各模块重复实现，禁止再各写一份）
// 统一 YYYY-MM-DD 字符串 ↔ 本地时区 ms 时间戳，及 M.D / YYYY.M.D / M月D日 格式化。
// 供 date-range-picker / todo-editor / todo-cache / todo-view / project-feature / stage-dates 共用。

// YYYY-MM-DD → 当天 0 点（本地时区）ms 时间戳；空/非法返回 0
export function dateStrToTs(str) {
  if (!str) return 0;
  var parts = String(str).split('-');
  if (parts.length !== 3) return 0;
  return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2])).getTime();
}

// ms 时间戳 → YYYY-MM-DD（本地时区）；空/非法返回 ''
export function tsToDateStr(ts) {
  if (!ts) return '';
  var d = new Date(ts);
  if (isNaN(d.getTime())) return '';
  var pad = function(n) { return n < 10 ? '0' + n : '' + n; };
  return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
}

// 别名（todo-view 既有命名）
export function toDateStr(ts) {
  return tsToDateStr(ts);
}

// 今天（本地时区）YYYY-MM-DD
export function todayStr() {
  var d = new Date();
  var pad = function(n) { return n < 10 ? '0' + n : '' + n; };
  return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
}

// '2026-06-29' → '6.29'
export function fmtMD(s) {
  var p = String(s || '').split('-');
  if (p.length !== 3) return '';
  return Number(p[1]) + '.' + Number(p[2]);
}

// '2026-12-20' → '2026.12.20'（跨年两端补年份）
export function fmtMDY(s) {
  var p = String(s || '').split('-');
  if (p.length !== 3) return '';
  return p[0] + '.' + Number(p[1]) + '.' + Number(p[2]);
}

// '2026-06-29' → '6月29日'
export function fmtCN(s) {
  var p = String(s || '').split('-');
  if (p.length !== 3) return '';
  return Number(p[1]) + '月' + Number(p[2]) + '日';
}

// 相对日期表述：今天/明天/昨天/本周X/下周X/X天后/X天前（跨周不显示具体日期）
export function formatRelativeDate(ts) {
  if (!ts) return '-';
  var d = new Date(ts);
  if (isNaN(d.getTime())) return '-';
  var today = new Date(); today.setHours(0, 0, 0, 0);
  var target = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  var diff = Math.round((target - today) / 86400000);
  var week = ['日', '一', '二', '三', '四', '五', '六'];
  if (diff === 0) return '今天';
  if (diff === 1) return '明天';
  if (diff === -1) return '昨天';
  if (diff > 1 && diff <= 7) {
    var dayOfWeek = today.getDay() || 7; // 周一=1 ... 周日=7
    var thisMonday = new Date(today);
    thisMonday.setDate(today.getDate() - (dayOfWeek - 1));
    var nextMonday = new Date(thisMonday);
    nextMonday.setDate(thisMonday.getDate() + 7);
    var prefix = target < nextMonday ? '本周' : '下周';
    return prefix + week[target.getDay()];
  }
  if (diff > 7) return diff + '天后';
  if (diff < -1) return Math.abs(diff) + '天前';
  return toDateStr(ts);
}
